import React from 'react';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import { Helmet } from 'react-helmet';

export function Main({
  children,
  noTopPadding,
  title = 'Advocare Kancelaria Adwokacka w Gdańsku',
}: React.PropsWithChildren<{
  noTopPadding?: boolean;
  title?: string;
}>): JSX.Element {
  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Advocare Kancelaria Adwokacka w Gdańsku - Adwokat Anna Sklinda-Maciejewska, Adwokat Alicja
          Wojciechowska"
        />
        <meta
          name="keywords"
          content="advocare, kancelaria, kancelaria adwokacka, kancelaria adwokacka gdańsk, adwokat, adwokat trójmiasto, adwokat gdańsk, kancelarie adwokackie gdańsk, kancelaria prawna gdańsk"
        />
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
          integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Header />
      <main
        style={{
          paddingTop: noTopPadding ? 0 : '40px',
        }}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}
